import { fun_PostAction } from "@/api/index";
export default {
  data() {
    return {
      // 默认关闭
      dialogVisible: false,
      // 联合体标志
      unionFlag: null,
      // 单位类型
      unitType: null,
      // 表头
      title: null,
      // 加载
      loading: false,
      // 查询表单绑定值
      form: {
        corpName: null // 企业名称
      },
      // 查询表单基础数据
      formSearchList: [
        {
          type: "input",
          label: "企业名称：",
          value: "corpName",
          placeholder: "请输入",
          clearable: true
        }
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "企业名称",
          prop: "corpName",
          isShow: true,
          fixed: true,
          width: "200"
        },
        {
          label: "社会信用代码",
          prop: "corpCode",
          fixed: true,
          width: "200"
        },
        {
          label: "工商营业执照注册号",
          prop: "licenseNum",
          width: "200"
        },
        {
          label: "企业登记注册类型",
          prop: "economicNumName",
          width: "180"
        },
        {
          label: "法定代表人姓名",
          prop: "legalMan",
          width: "150"
        },
        {
          label: "成立日期",
          prop: "corpBirthDate",
          width: "150"
        },
        {
          label: "企业网址",
          prop: "url",
          width: "200"
        },
        {
          label: "注册所在省（自治区、直辖市）",
          prop: "provinceNumName",
          width: "250"
        },
        {
          label: "注册所在地（市、州、盟）",
          prop: "cityNumName",
          width: "220"
        },
        {
          label: "注册所在县（区、市、旗）",
          prop: "countyNumName",
          width: "220"
        },
        {
          label: "住所",
          prop: "address",
          width: "200"
        }
      ],
      // 列表数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 分页总条数
      total: 0
    };
  },

  // 接收父组件传递的数据
  props: {
    // 招标登记编号
    registrationId: {
      type: String
    },
    // 是否显示登录企业标志
    invitationUnionFlag: {
      type: String
    },
    // 页面类型
    pageFlag: {
      type: String
    }
  },

  // 模板编译完成
  mounted() {},
  // 自定义方法
  methods: {
    // 打开弹框时调用
    async fun_GetOpen() {
      // 如果不是联合体
      if (this.unionFlag == "0") {
        // 施工单位
        if (this.unitType == "construction") {
          this.title = "施工单位";
        }
        // 勘察单位
        else if (this.unitType == "econ") {
          this.title = "勘察单位";
        }
        // 设计单位
        else if (this.unitType == "design") {
          this.title = "设计单位";
        }
        // 监理单位
        else if (this.unitType == "super") {
          this.title = "监理单位";
        }
      }
      // 如果是联合体
      else {
        this.title = "联合体单位";
      }
      // 查询一览数据
      this.fun_GetList();
    },
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 打开loading
      this.loading = true;
      // 发起请求
      fun_PostAction("/corpBasicinfoChoose/projectBasicInfoChoose", {
        ...this.form,
        ...this.reqPageData,
        flag: "zjfb"
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      });
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 企业选择
     */
    fun_CorpSelect(e) {
      // 回调函数
      this.$nextTick(() => {
        // 如果是联合体打开
        if (this.unionFlag == "1") {
          // 赋值父页面数据
          this.$parent.fun_SetUnionBasicInfo(e.val);
        } else {
          // 赋值父页面数据
          this.$parent.fun_SetCorpBasicInfo(e.val, this.unitType);
        }
        // 清空查询条件
        this.form.corpName = null;
        // 关闭页面弹框
        this.dialogVisible = false;
      });
    }
  }
};
